import React from 'react';

import { Box, HStack } from '@chakra-ui/react';
import { customTheme } from 'theme';

import {
  CheckmarkCircleIcon,
  PermissionsActionsIcon,
  QuestionCircleIcon,
} from 'components/Icons';
import { AutomaticallyPrepAzureSubscriptionForOnboarding } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/MicrosoftAzure/Help/AutomaticallyPrepAzureSubscriptionForOnboarding';
import { GetInputParameters } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/MicrosoftAzure/Help/GetInputParameters';
import { GettingManagementGroupId } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/MicrosoftAzure/Help/GettingManagementGroupId';
import { GettingSubscriptionId } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/MicrosoftAzure/Help/GettingSubscriptionId';
import { PermissionsRequiredForOnboarding } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/MicrosoftAzure/Help/PermissionsRequiredForOnboarding';
import { AzureOnboardingHelp } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/MicrosoftAzure/types';
import { CommandToEnableRemediation } from 'containers/Setup/CloudAccounts/Components/Remediation/CommandToEnableRemediation';

export const azureHelpHeaderMapping = (
  type: AzureOnboardingHelp,
  subscriptionId: string,
) => {
  switch (type) {
    case AzureOnboardingHelp.GettingManagementGroupId:
      return {
        header: 'Getting Management Group ID from Azure portal',
        content: <GettingManagementGroupId />,
        icon: <PermissionsActionsIcon />,
      };
    case AzureOnboardingHelp.GettingSubscriptionId:
      return {
        header: 'Getting Subscription ID from Azure portal',
        content: <GettingSubscriptionId />,
        icon: <PermissionsActionsIcon />,
      };
    case AzureOnboardingHelp.ManagementGroupPermissions:
      return {
        header: 'Permissions required for Onboarding',
        content: <PermissionsRequiredForOnboarding />,
        icon: <PermissionsActionsIcon />,
      };
    case AzureOnboardingHelp.InputParameters:
      return {
        header: 'Permissions required for Onboarding',
        content: <GetInputParameters />,
        icon: <CheckmarkCircleIcon />,
      };
    case AzureOnboardingHelp.Onboarding:
      return {
        header: 'Automatically prep Azure Subscription for Onboarding',
        content: (
          <AutomaticallyPrepAzureSubscriptionForOnboarding
            subscriptionId={subscriptionId}
          />
        ),
        icon: <CheckmarkCircleIcon />,
      };
    case AzureOnboardingHelp.Remediation:
      return {
        header: 'Command to enable remediation for Azure Subscription',
        content: <CommandToEnableRemediation subscriptionId={subscriptionId} />,
        icon: <CheckmarkCircleIcon />,
      };
  }
};

export const renderHelp = () => {
  return (
    <HStack spacing={1} cursor="pointer">
      <QuestionCircleIcon w={4} h={4} />
      <Box fontSize="sm" color={customTheme.colors.gray['300']}>
        Where's this?
      </Box>
    </HStack>
  );
};
